import { h$1 as g, h as v, a as p, me as $, Y as l, v as k, u$1 as z, c as B, m as E, o as w } from "../chunks/register-Ba9sFUKZ.js";
import * as x from "react";
import { d } from "../chunks/query-DoAo5UXi.js";
import { l as m } from "../chunks/query-all-_71klivX.js";
import { u as S } from "../chunks/class-map-B8OdeXIO.js";
import { o as u } from "../chunks/map-gLOTYKyP.js";
import { d as h } from "../chunks/lifecycle-decorators-C04d1yHY.js";
import { q as R } from "../chunks/query-assigned-DFc_RnLg.js";
import { u as V } from "../chunks/showIfUsed-5lEKgJ0L.js";
import { i as I } from "../chunks/utils-DQdPnNxR.js";
const y = {
  beaconTagName: "beacon-segmented-controls"
}, N = g`.radios{background-color:var(--beacon-system-color-background-1);border-color:var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-round);border-style:solid;border-width:var(--beacon-system-width-border-mini);display:flex;gap:var(--beacon-reference-space-2);inline-size:fit-content;padding:var(--beacon-reference-space-2);position:relative}.radios .control{flex-shrink:0}.radios[inert]{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px;padding:var(--beacon-reference-space-2)}[type=radio]{opacity:0;pointer-events:none;position:absolute}[type=radio]+label{align-items:center;border-radius:var(--beacon-system-radius-corner-round);color:var(--beacon-system-color-text-secondary);display:flex;gap:var(--beacon-reference-space-3)}[type=radio]+label svg{block-size:var(--beacon-reference-space-5);color:var(--beacon-system-color-icon-secondary);inline-size:var(--beacon-reference-space-5)}[type=radio]+label path{fill:currentcolor}[type=radio]:not(:disabled)+label{cursor:pointer}[type=radio]:not(:disabled):not(:checked)+label:hover{background-color:var(--beacon-system-color-background-secondary-hover)}[type=radio]:disabled+label{color:var(--beacon-system-color-text-secondary-inactive)}[type=radio]:disabled+label svg{color:var(--beacon-system-color-icon-secondary-inactive)}[type=radio]:active:not(:disabled,:checked)+label:hover{background-color:var(--beacon-system-color-background-secondary-pressed)}[type=radio]:checked+label{background-color:var(--beacon-system-color-background-primary);color:var(--beacon-system-color-text-primary)}[type=radio]:checked+label svg{color:var(--beacon-system-color-icon-primary)}[type=radio]:checked:disabled+label{background-color:var(--beacon-system-color-background-primary-inactive);color:var(--beacon-system-color-text-primary-inactive)}[type=radio]:checked:disabled+label svg{color:var(--beacon-system-color-icon-primary-inactive)}[type=radio]:focus-visible+label{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}.title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-headline-50);margin:0;margin-block-end:var(--beacon-reference-space-3);padding:0}.base{border:0;margin:0;padding:0;position:relative}.base:not(.compact) .select{display:none}.base.normal label{font:var(--beacon-system-font-weight-bold) var(--beacon-component-button-normal-font-size-sans-serif-standard);padding:var(--beacon-reference-space-4)}.base.mini label{font:var(--beacon-system-font-weight-bold) var(--beacon-component-button-mini-font-size-sans-serif-standard);padding:var(--beacon-reference-space-3)}.base.disabled .radios{border-color:var(--beacon-system-color-border-secondary-inactive)}select{color:var(--beacon-system-color-text-standard)}::part(field){inline-size:100%}::part(field):focus-within{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}`;
var O = Object.defineProperty, T = Object.getOwnPropertyDescriptor, a = (s, e, o, r) => {
  for (var n = r > 1 ? void 0 : r ? T(e, o) : e, c = s.length - 1, i; c >= 0; c--)
    (i = s[c]) && (n = (r ? i(e, o, n) : i(n)) || n);
  return r && n && O(e, o, n), n;
};
const b = class extends $ {
  constructor() {
    super(...arguments), this.beaconTagName = y.beaconTagName, this.focusOverride = !0, this.resetSpacing = !0, this.scale = "normal", this.disabled = !1, this.value = void 0, this.controlsList = [], this.compact = !1;
  }
  static get styles() {
    return [super.styles, N];
  }
  handleDefaultSlotchange() {
    this.controls.find(
      (e) => e.selected
    ) || (this.controls[0].selected = !0, this.setDefaultValue()), this.controlsList = [...this.controls];
  }
  renderRadioButtons() {
    return l`${u(
      this.controlsList,
      (e) => l`
        <div class="control">
          <input
            focus-override
            ?checked=${e.selected}
            type="radio"
            name="controls"
            id="control--${e.normalizedValue ? e.normalizedValue : e.value}"
            value="${e.normalizedValue ? e.normalizedValue : e.value}" />
          <label
            for="control--${e.normalizedValue}"
            id="label--${e.normalizedValue ? e.normalizedValue : e.value}">
            ${e.icon ? l`${e.icon.cloneNode(!0)}` : l``}
            <span class="label-text"
              >${e.text ? e.text : e.value}</span
            >
          </label>
        </div>
      `
    )}`;
  }
  renderSelectMenu() {
    const e = l`${u(
      this.controlsList,
      (o) => l`
        <option
          ?selected=${o.selected}
          id="option--${o.normalizedValue}"
          value="${o.normalizedValue}">
          ${o.text}
        </option>
      `
    )}`;
    return k`
      <${this.getScopedTag("beacon-control")}>
        <select ?disabled=${this.disabled} aria-labelledby="title">
          ${e}
        </select>
      </${this.getScopedTag("beacon-control")}>
    `;
  }
  // this event won't fire when we use JS to check a radio button
  handleRadioInputEvent(e) {
    const { target: o } = e;
    if (!(o instanceof HTMLInputElement)) return;
    this.value = o.value;
    const r = Array.from(this.options).find(
      (n) => n.value === o.value
    );
    r.selected = !0, this.emitSegmentInput();
  }
  // this event won't fire when we use JS to select an option
  handleSelectInputEvent(e) {
    const { target: o } = e;
    if (!(o instanceof HTMLSelectElement)) return;
    this.value = o.value;
    const r = Array.from(this.radioButtons), n = o.selectedOptions[0], c = r.find(
      (i) => i.value === n.value
    );
    c.checked = !0, this.emitSegmentInput();
  }
  emitSegmentInput() {
    z(this, B.INPUT, {
      detail: {
        value: this.value
      }
    });
  }
  applyBaseResizeObserver() {
    const e = (r) => {
      for (const n of r) {
        const { target: c } = n, { clientWidth: i } = c, { scrollWidth: f } = this.radiosContainer;
        f > i ? this.compact = !0 : this.compact = !1;
        return;
      }
    }, o = new ResizeObserver(I(e, 100));
    this.baseResizeObserver = o, this.baseResizeObserver.observe(this.base);
  }
  setDefaultValue() {
    const e = this.controls.find(
      (o) => o.selected
    );
    e && (this.value = e.value);
  }
  render() {
    const e = {
      base: !0,
      compact: this.compact,
      disabled: this.disabled
    };
    return e[this.scale] = !0, l`
      <slot
        style="display: none;"
        @slotchange=${this.handleDefaultSlotchange}
        @beacon-event-change=${this.handleDefaultSlotchange}></slot>
      <fieldset class="${S(e)}" ?disabled=${this.disabled}>
        <legend class="title" id="title">
          <slot name="title" ${V({ useParent: !0 })}></slot>
        </legend>
        <div
          ?inert=${this.compact}
          class="radios"
          @input=${this.handleRadioInputEvent}>
          ${this.renderRadioButtons()}
        </div>
        <div class="select" @input=${this.handleSelectInputEvent}>
          ${this.renderSelectMenu()}
        </div>
      </fieldset>
    `;
  }
};
b.tagName = y.beaconTagName, b.nestedComponents = ["beacon-control"];
let t = b;
a([
  v()
], t.prototype, "scale", 2);
a([
  v({ type: Boolean })
], t.prototype, "disabled", 2);
a([
  p()
], t.prototype, "value", 2);
a([
  p()
], t.prototype, "controlsList", 2);
a([
  p()
], t.prototype, "compact", 2);
a([
  d(".base")
], t.prototype, "base", 2);
a([
  d(".radios")
], t.prototype, "radiosContainer", 2);
a([
  d('[type="radio"]:checked')
], t.prototype, "checkedRadio", 2);
a([
  d("select")
], t.prototype, "select", 2);
a([
  m('[type="radio"]')
], t.prototype, "radioButtons", 2);
a([
  m("option")
], t.prototype, "options", 2);
a([
  R({ selector: "beacon-segmented-control" }, !0)
], t.prototype, "controls", 2);
a([
  h
], t.prototype, "applyBaseResizeObserver", 1);
a([
  h
], t.prototype, "setDefaultValue", 1);
const F = (s) => (E(s, t), w({
  tagName: s ? s + "-" + t.tagName : t.tagName,
  elementClass: t,
  react: x,
  events: {
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  F as default,
  F as reactBeaconSegmentedControls
};
